import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProsp {
  title: string;
  description?: string;
}

export default function SEO({ title, description }: SEOProsp) {
  return (
    <Helmet>
      {/* Brending pariteti (egasi 2026-09-02): har sahifa sarlavhasi tizim nomi bilan */}
      <title>{title ? title + " — SAV ERP" : "SAV ERP"}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
}
